module.exports = __webpack_public_path__ + "img/IMG_20191125_200003.f4df2639.jpg";